import { useEffect } from 'react'
import { NewPasswordForm } from './NewPasswordForm'
import { ResetPasswordSuccess } from './ResetPasswordSuccess'
import { useLoading } from '@/contexts/LoadingContext'
import { useTranslation } from 'react-i18next'
import { useResetPassword } from '@/hooks/useAuth'

interface NewPasswordData {
  password: string
  confirmPassword: string
}

interface NewPasswordProps {
  token: string
}

export function NewPassword({ token }: NewPasswordProps) {
  const { t } = useTranslation()
  const { isLoading, error, isSuccess, handleSubmit } = useResetPassword()
  const { showLoading, hideLoading } = useLoading()

  useEffect(() => {
    if (isLoading) {
      showLoading(t('auth.resettingPassword'))
    } else {
      hideLoading()
    }
  }, [isLoading, showLoading, hideLoading, t])

  const onSubmit = async (data: NewPasswordData) => {
    await handleSubmit(token, data.password, data.confirmPassword)
  }

  if (isSuccess) {
    return <ResetPasswordSuccess />
  }

  return (
    <NewPasswordForm
      onSubmit={onSubmit}
      isLoading={isLoading}
      error={error || undefined}
    />
  )
}
